export const editorTheme = {
  paragraph: 'mt-4 ml-3',
  heading: {
    h1: 'text-3xl font-bold mb-4 ml-3',
    h2: 'text-2xl font-bold mb-3 ml-3',
    h3: 'text-xl font-bold mb-2 ml-3',
  },
  text: {
    bold: 'font-bold',
    italic: 'italic',
    underline: 'underline',
    strikethrough: 'line-through',
    subscript: 'align-sub text-xs',
    superscript: 'align-super text-xs',
  },
  link: 'text-blue-600 underline hover:text-blue-800',
  list: {
    ul: 'list-disc list-inside mb-2',
    ol: 'list-decimal list-inside mb-2',
    listitem: 'mb-1',
  },
}
